var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order_detail" },
    [
      _c("div", { staticClass: "order_head" }, [
        _c("div", { staticClass: "order_head_title flex" }, [
          _c(
            "div",
            {
              staticClass: "page_title",
              staticStyle: { width: "1%", "margin-right": "30px" }
            },
            [
              _c("custom-breadcrumb", {
                attrs: { suffix: "Order NO. " + _vm.orderId }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "page_button" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_nav flex" }, [
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Order total")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.tsStoreOrderInfo["payAmount"]))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Orders Date")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.orderDate))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Orders Status")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.orderStatus))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex address_width" }, [
            _c(
              "p",
              { staticClass: "nac_msg_name" },
              [
                _vm._v("\n            Ship To\n            "),
                !_vm.finalStatus.includes(_vm.tsStoreOrderInfo["orderStatus"])
                  ? [
                      _c("span", { on: { click: _vm.openAddress } }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/memo.png"),
                            alt: ""
                          }
                        })
                      ])
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.isVidirect ||
            (_vm.tsStoreOrderInfo["orderStatus"] !== 0 &&
              _vm.tsStoreOrderInfo["orderStatus"] !== 1 &&
              _vm.tsStoreOrderInfo["orderStatus"] !== 2 &&
              _vm.tsStoreOrderInfo["orderStatus"] !== 10 &&
              _vm.tsStoreOrderInfo["orderStatus"] !== 11)
              ? _c(
                  "p",
                  {
                    staticClass: "nac_msg_num",
                    staticStyle: { "padding-top": "0px" }
                  },
                  [
                    _vm.isVidirect || _vm.brandShippingModel === "2"
                      ? [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.tsStoreOrderAddress.name) +
                              "  " +
                              _vm._s(_vm.tsStoreOrderAddress.lastname) +
                              "\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.tsStoreOrderAddress.address) +
                              " \n              "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.tsStoreOrderAddress.city) +
                              ", " +
                              _vm._s(_vm.tsStoreOrderAddress.province) +
                              ", " +
                              _vm._s(_vm.tsStoreOrderAddress.countryName) +
                              "  " +
                              _vm._s(_vm.tsStoreOrderAddress.postCode) +
                              "\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.tsStoreOrderAddress.areaCode) +
                              "-" +
                              _vm._s(_vm.tsStoreOrderAddress.phone) +
                              "\n            "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n              ShopVidi（收）\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n              深圳市宝安区福海街道新和社区红牌工业园华丰智谷福海科技产业园A栋 A326-1\n              "
                          ),
                          _c("br"),
                          _vm._v("\n              18038059068\n            ")
                        ]
                  ],
                  2
                )
              : _c("p", [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav_msg flex", staticStyle: { width: "20%" } },
            [
              _c("p", { staticClass: "nac_msg_name no_border" }, [
                _vm._v("Customer")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "nac_msg_num no_border" }, [
                _vm._v(_vm._s(_vm.customer))
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order_main" },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.skuList } },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "Item", width: "420" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "prduct_box" }, [
                          _c("img", {
                            staticClass: "product_img",
                            attrs: { src: scope.row.skuImg, alt: "" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "product_info" }, [
                            _c("p", { staticClass: "product_name" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row.skuName) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "product_size" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row["finalSkuName"]) +
                                  "\n                  "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#8F8F8F",
                                    "margin-left": "15px",
                                    "font-size": "14px"
                                  }
                                },
                                [_vm._v(" " + _vm._s(scope.row["skuCode"]))]
                              )
                            ]),
                            _vm._v(" "),
                            scope.row.orderStatus === 3
                              ? _c("div", { staticClass: "product_tips" }, [
                                  _vm._v("The item is shipped")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.orderStatus === 7
                              ? _c("div", { staticClass: "product_tips" }, [
                                  _vm._v("The item is refunded")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.orderStatus === 16
                              ? _c("div", { staticClass: "product_tips" }, [
                                  _vm._v("The item is refunding")
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "FOB Price", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "prduct_box flex" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("fixed2")(scope.row["fobPriceFinal"])
                              )
                            )
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Wholesale Price", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "prduct_box flex" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm._f("fixed2")(scope.row.unitPrice)) +
                              "\n            "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Qty", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "prduct_box flex qty-left" }, [
                          _c("span", [_vm._v(_vm._s(Number(scope.row["num"])))])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Out of Stock Qty", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "prduct_box flex qty-left" }, [
                          _c("span", [
                            _vm._v(_vm._s(Number(scope.row["stockNum"])))
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                staticStyle: { position: "relative" },
                attrs: { label: "Pending Shipment QTY", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "flex qty-left" },
                          [
                            _c("el-input", {
                              staticClass: "price_input",
                              attrs: {
                                oninput:
                                  "if(value){value=value.replace(/[^\\d]/g,'')} ",
                                disabled:
                                  (_vm.tsStoreOrderInfo["orderStatus"] !== 4 &&
                                    scope.row["serviceOrderStatus"] == 2) ||
                                  scope.row.orderStatus === 3 ||
                                  scope.row.orderStatus === 7 ||
                                  scope.row.orderStatus === 16,
                                placeholder: "Pending Shipment QTY"
                              },
                              on: {
                                change: function(e) {
                                  return _vm.changeNum(
                                    e,
                                    scope.$index,
                                    scope["row"]
                                  )
                                }
                              },
                              model: {
                                value: scope.row["pendingShipmentQTY"],
                                callback: function($$v) {
                                  _vm.$set(scope.row, "pendingShipmentQTY", $$v)
                                },
                                expression: "scope.row['pendingShipmentQTY']"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !scope["row"]["serviceOrderWaitNum"] &&
                                      scope["row"]["serviceOrderWaitNum"] !== 0,
                                    expression:
                                      "!scope['row']['serviceOrderWaitNum'] && scope['row']['serviceOrderWaitNum']!==0"
                                  }
                                ],
                                staticClass: "required-error",
                                staticStyle: { top: "85px" }
                              },
                              [_vm._v("Can't be blank")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Shipped Qty", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "prduct_box flex qty-left" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(Number(scope.row["thirdDeliveredNum"]))
                            )
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Total" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "flex total_amount" }, [
                          _c("span", [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm._f("fixed2")(
                                    Number(
                                      !scope.row["isSkuChangePrice"]
                                        ? scope.row["unitPrice"]
                                        : scope.row["unitPriceBeforeDiscount"]
                                    ) * Number(scope.row["num"])
                                  )
                                )
                            )
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.orderStatus !== "Unpaid" && _vm.orderStatus !== "Failed"
                ? _c("el-table-column", {
                    attrs: { label: "Item Status", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope["row"]["showStatusSelect"]
                                ? _c(
                                    "div",
                                    { staticClass: "table-cell-input" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "Please Select",
                                            disabled:
                                              (_vm.tsStoreOrderInfo[
                                                "orderStatus"
                                              ] !== 4 &&
                                                scope.row[
                                                  "serviceOrderStatus"
                                                ] == 2) ||
                                              scope.row.orderStatus === 3 ||
                                              scope.row.orderStatus === 7 ||
                                              scope.row.orderStatus === 16
                                          },
                                          on: {
                                            change: function(e) {
                                              return _vm.changeSkuStatus(
                                                e,
                                                scope.row,
                                                scope.$index
                                              )
                                            }
                                          },
                                          model: {
                                            value: scope.row["skuStatus"],
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "skuStatus",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row['skuStatus']"
                                          }
                                        },
                                        _vm._l(_vm.skuStatusOptions, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                              disabled:
                                                item.value == 1 &&
                                                scope["row"]["stockNum"] > 0
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "table-cell-input" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "12px",
                                            color: "#FB541C"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Restock by " +
                                              _vm._s(
                                                scope["row"]["restockDate"]
                                              )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cust-sku-btn",
                                          staticStyle: { "text-align": "left" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.resetRestock(
                                                    scope["row"],
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Restock")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.showSetDate(
                                                    scope["row"],
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Change Date")]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope["row"]["tmpStatus"] == "99",
                                      expression:
                                        "scope['row']['tmpStatus']=='99' "
                                    }
                                  ],
                                  staticClass: "set-restock-date"
                                },
                                [
                                  _c("p", [_vm._v("Set restock date")]),
                                  _vm._v(" "),
                                  _c("el-date-picker", {
                                    staticStyle: { "margin-top": "10px" },
                                    attrs: {
                                      type: "date",
                                      disabled:
                                        (_vm.tsStoreOrderInfo["orderStatus"] !==
                                          4 &&
                                          scope.row["serviceOrderStatus"] ==
                                            2) ||
                                        scope.row.orderStatus === 3 ||
                                        scope.row.orderStatus === 7 ||
                                        scope.row.orderStatus === 16 ||
                                        scope.row["serviceOrderStatus"] == 3,
                                      "value-format": "MM/dd/yyyy",
                                      placeholder: "MM/DD/YYYY",
                                      format: "MM/dd/yyyy"
                                    },
                                    on: {
                                      change: function(e) {
                                        return _vm.changeRestockDate(
                                          e,
                                          scope["row"],
                                          scope.$index
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.restockDateArr[scope.$index],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.restockDateArr,
                                          scope.$index,
                                          $$v
                                        )
                                      },
                                      expression: "restockDateArr[scope.$index]"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.restockDateArr[
                                            scope.$index
                                          ],
                                          expression:
                                            "!restockDateArr[scope.$index]"
                                        }
                                      ],
                                      staticClass: "required-error"
                                    },
                                    [_vm._v("Please set restock date")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "cust-sku-btn" }, [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.submitRestockDate(
                                              scope["row"],
                                              scope.$index,
                                              false
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Cancel")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.submitRestockDate(
                                              scope["row"],
                                              scope.$index,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Save")]
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1122373197
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "order_footer" }, [
        _c(
          "div",
          { staticClass: "sync-sku" },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.isSyncSku,
                  callback: function($$v) {
                    _vm.isSyncSku = $$v
                  },
                  expression: "isSyncSku"
                }
              },
              [
                _vm._v(
                  "Synchronize setting the SKU items in the order as inactive."
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tips-txt" }, [
          _vm._v(
            "If the item in the order is temporarily out of stock, select “Out of Stock” and set a replenishment date.\n        If the product cannot be restocked within a short time, please select Inactive to unshelf the product"
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn add-btn", on: { click: _vm.showConfirm } },
          [_vm._v("Submit")]
        )
      ]),
      _vm._v(" "),
      _c("Address", {
        ref: "address",
        attrs: { addressMessage: _vm.addressMessage }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            visible: _vm.visible,
            "close-on-click-modal": false,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "back_icon",
              on: {
                click: function($event) {
                  _vm.visible = false
                }
              }
            },
            [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("Back")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "success_text" }, [
            _vm._v(
              "It cannot be updated after operation, please operate with caution!"
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex_all" },
            [
              _c(
                "el-button",
                {
                  staticClass: "back_button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [_vm._v("\n          Confirm\n        ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bd2011d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd2011d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/edit-item-avaliability.vue
// module id = SGTn
// module chunks = 2